import React from 'react';
import styled from 'styled-components';
import { CustomTooltip } from '../../../../general_components/content_management/reusableItems/tooltips';
import { addressExtractor } from '../../../../general_components/content_management/task_list/taskListElements/listView';

const FinalDestinationContainer = styled.div`
    &>span{
        cursor:default;
        color:var(--gray);
        font-weight:600;
    }
    :hover{
        .tooltip{
            visibility: visible;
            transition-property: visibility;
            transition-delay: 0.7s;
        }
    }
`
export const MB_DESTINATION = ({tasks}) => {
    const lastTask = tasks && tasks.length > 0 && tasks[tasks.length-1] ? tasks[tasks.length-1] : null;
    const finalDestAddress =  lastTask ? addressExtractor(lastTask.address) : null;
    
    const fullInfo = finalDestAddress ? 
    `${lastTask.apptDate ? `${lastTask.apptDate}\n` : ""}${lastTask.apptTime ? `${lastTask.apptTime}\n`:''}${finalDestAddress.companyName}\n${finalDestAddress.city}, ${finalDestAddress.state} ${finalDestAddress.postalCode}` 
    : null;
    return <FinalDestinationContainer>
        {finalDestAddress ? 
        <>
            <span>
                {`${finalDestAddress.city ? finalDestAddress.city+", " : ''}${finalDestAddress.state}`}
            </span>
            <CustomTooltip info={fullInfo} marginTop={"0.9rem"} xDisposition="-3rem" />
        </>
        : '-'}
    </FinalDestinationContainer>
}